import useOnAnnotationContentOverlayOpen from './useOnAnnotationContentOverlayOpen';

export default useOnAnnotationContentOverlayOpen;